var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-phbalance"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Benefits/PH-Balance",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-phbalance"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-phbalance"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,25 C12.447,25 12,24.552 12,24 C12,23.448 12.447,23 13,23 L15,23 C15.553,23 16,23.448 16,24 C16,24.552 15.553,25 15,25 L13,25 Z M22.434,20 L13.566,20 L11.285,23.802 C11.099,24.113 11,24.468 11,24.831 L11,25 C11,25.551 11.448,26 12,26 L24,26 C24.552,26 25,25.551 25,25 L25,24.831 C25,24.468 24.901,24.113 24.715,23.803 L22.434,20 Z M25,25 C25,25.551 24.552,26 24,26 L12,26 C11.448,26 11,25.551 11,25 L11,24.831 C11,24.468 11.099,24.113 11.285,23.802 L16.857,14.515 C16.951,14.359 17,14.181 17,14 L17,9 L19,9 L19,14 C19,14.181 19.049,14.359 19.143,14.515 L24.715,23.803 C24.901,24.113 25,24.468 25,24.831 L25,25 Z M27,24.831 C27,24.105 26.803,23.394 26.43,22.773 L21,13.723 L21,9 C21.553,9 22,8.552 22,8 C22,7.448 21.553,7 21,7 L20,7 L16,7 L15,7 C14.447,7 14,7.448 14,8 C14,8.552 14.447,9 15,9 L15,13.723 L9.57,22.772 C9.197,23.394 9,24.105 9,24.831 L9,25 C9,26.654 10.346,28 12,28 L24,28 C25.654,28 27,26.654 27,25 L27,24.831 Z",
    id: "Fill-1-phbalance",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhBalance);
export default __webpack_public_path__ + "static/media/PHBalance.0a89c8eb1bdf8251bc47249f9211475d.svg";
export { ForwardRef as ReactComponent };